/**
 * @module config
 * @description アプリケーションの設定と定数を提供するモジュール
 *
 * KronoMetro
 *
 * Copyright © 2019-present KronoMetro, Co. All rights reserved.
 *
 * 注意：env ファイルで読み込みは使わないこと
 *
 */

import muiTheme from "./muiTheme.js";
import { default as config } from "./config.js";

export { muiTheme };
export { default as Consts } from "./consts.js";
export { config };
